'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SvgImage = exports.SvgSymbol = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSideEffect = require('react-side-effect');

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _createSvgImage = require('../components/createSvgImage');

var _createSvgImage2 = _interopRequireDefault(_createSvgImage);

var _SvgSymbol = require('../components/SvgSymbol');

var _SvgSymbol2 = _interopRequireDefault(_SvgSymbol);

var _Spritesheet = require('../components/Spritesheet');

var _Spritesheet2 = _interopRequireDefault(_Spritesheet);

var _reducePropsToState = require('./reducePropsToState');

var _reducePropsToState2 = _interopRequireDefault(_reducePropsToState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleStateChangeOnClient(reducedProps) {
    var spritesheet = document.querySelector('#spritesheet');
    if (!spritesheet) {
        spritesheet = document.createElement('div');
        spritesheet.id = 'spritesheet';
        document.body.insertBefore(spritesheet, document.body.children[0]);
    }

    _reactDom2.default.render(_react2.default.createElement(_Spritesheet2.default, reducedProps), spritesheet);
} /* global document */
var SvgSymbol = exports.SvgSymbol = (0, _reactSideEffect2.default)(_reducePropsToState2.default, handleStateChangeOnClient)(_SvgSymbol2.default);

var SvgImage = exports.SvgImage = (0, _createSvgImage2.default)(SvgSymbol);
//# sourceMappingURL=client.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/targets/client.js
 ** module id = 358
 ** module chunks = 0
 **/